import { COMPRESSED_VALUE_SCALE } from 'constants/trade'
import numbro from 'numbro'
import { memo } from 'react'
import { useOrderbookPrecision } from 'store/orderbook/hooks'
import { OrderbookDataItem } from 'store/orderbook/types'
import { Ether } from 'types'
import { toFixed } from 'utils/number'
import { isOrderedPrice } from 'utils/orderbook/price'
import {
  ColorBGBuy,
  OrderbookRowBuy,
  OrderDot,
  PriceHolder,
} from 'views/Spot/OrderList/style'
import { OrderDirection } from 'store/spot/types'

export const OrderbookListBids = memo<{
  list: OrderbookDataItem[]
  userOrders: { price: number }[]
  baseScale: number
  quoteScale: number
  onClickPrice: (price: Ether) => void
}>(({ list, userOrders, baseScale, quoteScale, onClickPrice }) => {
  const precision = useOrderbookPrecision()
  const average = quoteScale >= COMPRESSED_VALUE_SCALE

  return (
    <PriceHolder>
      {list?.map((item) => (
        <OrderbookRowBuy
          key={item.price}
          direction={OrderDirection.LONG}
          className={item.animationFlag ? 'buy-bg-glint' : ''}
          onClick={() => onClickPrice(item.price)}
        >
          <ColorBGBuy $width={item.percent ?? '0'} />
          {isOrderedPrice(userOrders, item.price, precision) ? (
            <OrderDot $isBuy={true} />
          ) : null}
          <span className={'price'}>{item.price}</span>
          <span className={'amount'}>
            {numbro(item.amount).format({
              average,
              thousandSeparated: true,
              mantissa: average ? 2 : baseScale,
              optionalMantissa: true,
            })}
          </span>
          <span className={'total'}>
            {Number(
              toFixed(Number(item.price) * Number(item.amount), 2, {
                fixed: true,
              }),
            ).toLocaleString()}
          </span>
        </OrderbookRowBuy>
      ))}
    </PriceHolder>
  )
})
